import { render, staticRenderFns } from "./ProductsListView.vue?vue&type=template&id=656f8148"
import script from "./ProductsListView.vue?vue&type=script&lang=js"
export * from "./ProductsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports